var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarkerConstructionDisabled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 14H16V17H20V33C20 33.3333 20.2 34 21 34C21.8 34 22 33.3333 22 33V17H26V16C26 14.4 24.6667 14 24 14Z",
    fill: "#FFE399"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 14H29L28 18L29 20V25L28 27V32C28 32.6667 28.4 34 30 34C31.6 34 32 32.6667 32 32V27L31 25V20L32 18L31 14Z",
    fill: "#FFE399"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerConstructionDisabled);
export default __webpack_public_path__ + "static/media/marker_construction_disabled.013b55006e77a062121d74544d3c30fd.svg";
export { ForwardRef as ReactComponent };